import { catalogSummaryApi, shoppingApi } from 'app/src/services/welfareportal'
import { PortalDialog } from 'app/src/shared/components/Dialog'
import { calculatePercentage, euroFormatterIt } from 'app/src/shared/helpers'
import { useWebAppContext } from 'app/src/shared/hooks'
import { Button } from 'primereact/button'
import { useMemo, useState } from 'react'
import { buildStyles, CircularProgressbarWithChildren } from 'react-circular-progressbar'
import { useTranslation } from 'react-i18next'

export function FringeBenefitSpinner(props?: { pt?: { title?: { hide?: boolean; text?: string } } }) {
  const context = useWebAppContext()
  const credit = shoppingApi.useCreditGet(
    {},
    {
      meta: {
        skip404Errors: true,
      },
    },
  )
  const { t } = useTranslation('userAccount', { keyPrefix: 'WalletOverview' })
  const [showDialog, setShowDialog] = useState<boolean>(false)

  const catalogSummaryDetails = catalogSummaryApi.useCatalogSummaryList({
    pathParams: { templateBasePath: context.userInfo.welfareCampaign.configuration.frontend.templateId },
  })
  const fringeLimitBanner = useMemo(() => {
    return catalogSummaryDetails.data?.informativeBanners?.['FRINGELIMIT']
  }, [catalogSummaryDetails?.data?.informativeBanners])
  return (
    <>
      {showDialog && fringeLimitBanner && (
        <PortalDialog
          headerProps={{
            title: fringeLimitBanner.modal?.title ?? '',
          }}
          onHide={() => setShowDialog(false)}
          footerProps={{
            okCallBack: () => setShowDialog(false),
            okLabel: fringeLimitBanner.modal?.buttonLabel,
          }}
        >
          <div
            dangerouslySetInnerHTML={{
              __html: fringeLimitBanner.modal?.body ?? '',
            }}
          />
        </PortalDialog>
      )}
      <div className='text-center' data-testid='FringeBenefitSpinner'>
        {(typeof props?.pt?.title?.hide === 'undefined' || !props.pt.title.hide) && (
          <span
            className='mb-3 text-center text-xl font-bold'
            dangerouslySetInnerHTML={{ __html: props?.pt?.title?.text ?? t('FringeBenefitWidget.Title') }}
          ></span>
        )}

        <div className='mx-auto max-w-[200px] pt-2' data-testid='circular-progress-bar'>
          <CircularProgressbarWithChildren
            value={calculatePercentage(
              credit?.data?.creditByServiceCategory?.welfareArt51?.total ?? 0,
              credit?.data?.creditByServiceCategory?.welfareArt51?.available ?? 0,
            )}
            className='dynamic-blocks'
            styles={buildStyles({
              strokeLinecap: 'butt',
              pathColor: '#0047BB',
              trailColor: '#EAEAEA',
            })}
          >
            <div
              className='m-[10%] text-center text-base leading-[17px]'
              dangerouslySetInnerHTML={{
                __html: t('FringeBenefitWidget.SpinnerText', {
                  AVAILABLEFRINGECREDIT: euroFormatterIt.format(
                    credit?.data?.creditByServiceCategory?.welfareArt51?.available ?? 0,
                  ),
                }),
              }}
            ></div>
          </CircularProgressbarWithChildren>
          {fringeLimitBanner && (
            <Button link text pt={{ root: { className: 'underline pb-0  pl-0' } }} onClick={() => setShowDialog(true)}>
              {fringeLimitBanner.actionLabel}
            </Button>
          )}
        </div>
      </div>
    </>
  )
}
